import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoggedInUserService } from '../../../auth/logged.in.user';
import { CmsDialogDto } from '../../../models/cms.dialogs/cms.dialogs.models';
import { CmsDialogService } from '../../../services/cms.dialog.service';

@Component({
    selector: 'help-team-members',
    template: require('./help.team-members.component.html'),
    styles: [require('../personal.account.shared.css'), require('./help.team-members.component.css')]
})
export class HelpTeamMembersComponent implements OnInit, OnDestroy {
    content = '';

    constructor(
        private readonly cmsDialogService: CmsDialogService,
        private readonly userService: LoggedInUserService) { }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');

        const subscribed = !this.userService.getCurrentUser().canAdHoc('notSubscribed');
        const suffix = subscribed ? 'Subscribed' : 'Not Subscribed';
        const description = `Team Members - ${suffix}`;

        this.cmsDialogService.getByDescription(description).subscribe((result: CmsDialogDto) => {
            this.content = result.body || '';
        });
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.team-members.component.ts